import { ThemeProvider } from "@emotion/react";
import { createTheme } from "@mui/material";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "react-hot-toast";
import { RouterProvider } from "react-router-dom";
import "./App.css";
import { routerDefinition } from "./route/RouterDefinitaion";
import { NuqsAdapter } from 'nuqs/adapters/react-router'

const theme = createTheme({
  palette: {
    primary: {
      main: '#263238',
    },
  },
  typography: {
    fontFamily: "Kanit",
  },
});
const queryClient = new QueryClient({
  defaultOptions: {
    queries: { retry: false },
    mutations: { retry: false },
  },
});
function App() {
  return (
    <div className="App">
      <ThemeProvider theme={theme}>
        <QueryClientProvider client={queryClient}>
          <Toaster />
          <NuqsAdapter>
            <RouterProvider router={routerDefinition} />
          </NuqsAdapter>
        </QueryClientProvider>
      </ThemeProvider>
    </div>
  );
}

export default App;
